import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { SuccessToast, ErrorToast } from "../../../components/toast/Toasts";
import { IAgentDetails } from "../agentModel";

export const getAllAgent = createAsyncThunk(
  "SubAgents/FindAllSubAgents",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/SubAgents/FindAllSubAgents`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Agent:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveAgent = createAsyncThunk(
  "SubAgents/FindAllActiveSubAgents",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/SubAgents/FindAllActiveSubAgents`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Agent:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createAgent = createAsyncThunk(
  "SubAgents/Insert",
  async (AgentData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SubAgents/Insert`,
        AgentData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Agent:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteAgent = createAsyncThunk(
  "SubAgents/DeleteSubAgents",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SubAgents/DeleteSubAgents`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Agent:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
export const getAgentByID = createAsyncThunk(
  "SubAgents/FindByIDSubAgents",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SubAgents/FindByIDSubAgents`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        SubAgentName: result.SubAgentName,
        CompanyName: result.CompanyName,
        Password: result.Password,
        CompanyAddress: result.CompanyAddress,
        PinCode: result.PinCode,
        CountryID: result.CountryID,
        StateID: result.StateID,
        CityID: result.CityID,
        ContactNo: result.ContactNo,
        EmailID: result.EmailID,
        GSTNo: result.GSTNo,
        PanNo: result.PanNo,
        AadharNo: result.AadharNo,
        UniversalMarkupTypeID: result.UniversalMarkupTypeID,
        UniversalMarkup: result.UniversalMarkup,
        AadharDocument: result.AadharDocument,
        PanDocument: result.PanDocument,
        GSTDocument: result.GSTDocument,
        Logo: result.Logo,
        IsActive: result.IsActive ? 1 : 2,
        ContactDetails: result.ContactDetails
          ? result.ContactDetails.map((contact: any) => {
              return {
                ID: contact.ID ? contact.ID : null,
                Name: contact.Name ? contact.Name : "",
                MobileNo: contact.MobileNo ? contact.MobileNo : "",
                EmailID: contact.EmailID ? contact.EmailID : "",
                Designation: contact.Designation ? contact.Designation : "",
              };
            })
          : [],

        BankDetails: result.BankDetails
          ? result.BankDetails.map((bank: any) => {
              return {
                ID: bank.ID ? bank.AgentID : null,
                BankName: bank.BankName ? bank.BankName : "",
                BranchName: bank.BranchName ? bank.BranchName : "",
                AccountNo: bank.AccountNo ? bank.AccountNo : "",
                IFSCCode: bank.IFSCCode ? bank.IFSCCode : "",
              };
            })
          : [],
      } as IAgentDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Agent:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveAgent = createAsyncThunk(
  "SubAgents/ActiveInActiveSubAgents",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SubAgents/ActiveInActiveSubAgents`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Agent:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const agentdocumentupload = createAsyncThunk(
  "SubAgents/InsertDocuments",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SubAgents/InsertDocuments`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Agent Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
